module.exports = __webpack_public_path__ + "assets/img/icon_play.437d13ed.png";